var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ScheduleListByStaffComponent',{attrs:{"typeName":"定期清掃","type":3,"settionStrageName":"FixedSlbsStorageItemName","checkListDate":_vm.checkListDate,"userId":_vm.userId,"name":_vm.name,"routerName":"FixedCheckListTable"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }